import * as React from 'react';
import { useCallback, forwardRef, useMemo } from 'react';
import * as ReactDOM from 'react-dom';
import MaskedInput from 'react-text-mask';

import TextField, { TextFieldProps } from '../text-field';
import { detectIsTaxCode } from '../../utils/validation';
import { withFormTextField } from '../form';
import { ValidationRule, getValueByName } from '../form/shared';
import { Root } from './styled';


export type TaxCodeTextFieldProps = {
	enableOnChangeValidation?: boolean;
} & TextFieldProps;

const TextMask = (props) => {
	const { inputRef, ...rest } = props;
	const setRef = useCallback(ref => inputRef(ReactDOM.findDOMNode(ref)), []);

  return (
    <MaskedInput
      {...rest}
      ref={setRef}
			mask={[/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d?/,/\d?/]}
			placeholderChar={'\u2000'}
      keepCharPositions
    />
  );
}

const MaskedTextField = forwardRef<any, any>((props, ref) => {
	const { value, onChange } = props;

	return (
		<TextField
			{...props}
			ref={ref}
			InputProps={{
				inputComponent: TextMask,
				value,
				onChange,
			}}
		/>
	);
})

const TaxCodeTextField: React.SFC<TaxCodeTextFieldProps> = forwardRef((props, ref) => {
	const {
		value,
		fullWidth,
		enableOnChangeValidation,
		onChange,
		...rest
	} = props;
	const handleChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		const value = e.currentTarget.value.replace(/\s|\_/g, '');
		const isEmpty = !value;
		const isCompleted = value.length >= 10;

		if (isEmpty) {
			onChange(e, '');
		} else if (isCompleted) {
			onChange(e, value);
		}
	};

	const isValid = enableOnChangeValidation && value
		? detectIsTaxCode(value.toString())
		: true;
	const hasError = !isValid;

	return (
		<Root fullWidth={fullWidth}>
			<MaskedTextField
				ref={ref}
				value={value}
				label='ИНН'
				placeholder='772001XXXXX1'
				error={hasError}
				helperText={hasError ? 'Некорректный ИНН' : ''}
				fullWidth
				onChange={handleChange}
				{...rest}
			/>
		</Root>
	);
});

TaxCodeTextField.displayName = 'TaxCodeTextField';
TaxCodeTextField.defaultProps = {};

const FormTaxCodeTextFieldBase = withFormTextField<Omit<React.ComponentProps<typeof TaxCodeTextField>, 'name'>, any>(TaxCodeTextField);
const FormTaxCodeTextField: React.FC<React.ComponentProps<typeof FormTaxCodeTextFieldBase>> = props => {
	const { name } = props;
	const validationRules: Array<ValidationRule> = useMemo(() => ([{
		errorText: 'Некорректный ИНН',
		fn: (formObject) => {
			const value = getValueByName(name, formObject);
			const isValid = value
				? detectIsTaxCode(value.toString())
				: true;

			return isValid;
		},
	}]), []);

	return (
		<FormTaxCodeTextFieldBase
			{...props}
			validationRules={validationRules}
		/>
	);
};

export { FormTaxCodeTextField };
export default TaxCodeTextField;
